'use strict';

$(function () {
    var mousetimer = null;

    $(document).on("mouseenter", "#navigation", function () {
        var $self = $(this);

        if (mousetimer) {
            clearTimeout(mousetimer);
            mousetimer = null;
        }

        if (!window.isMobileDevice()) {
            if (mousetimer === null) {
                mousetimer = setTimeout(function () {
                    $self.addClass('mouse--in');
                    mousetimer = null;
                }, 300);
            }
        }
    }).on("mouseleave", function () {
        if (mousetimer) {
            clearTimeout(mousetimer);
            mousetimer = null;
        }

        if (!window.isMobileDevice()) {
            $(this).removeClass('mouse--in');
        }
    });
});
